<template>
  <Popover v-slot="{ close }" class="relative z-100">
    <Float
      :offset="10"
      :shift="16"
      :auto-placement="{
        autoAlignment: true,
        allowedPlacements: ['bottom-start']
      }"
    >
      <PopoverButton
        class="flex h-10 w-10 items-center justify-center rounded-full bg-primary text-contrast-primary active:scale-95 active:bg-primary-400 @3xl/main:flex @3xl/main:w-auto @3xl/main:flex-row @3xl/main:gap-2 @3xl/main:pr-4 @3xl/main:pl-3 dark:bg-primary-700 dark:active:bg-primary-600"
        data-testid="quick-add-button"
      >
        <FontAwesomeIcon :icon="['fal', 'plus']" size="lg" />
        <span
          class="hidden truncate text-center text-sm font-medium capitalize @3xl/main:inline"
        >
          {{ $t('button.add') }}
        </span>
      </PopoverButton>
      <PopoverPanel class="popover-panel z-100 w-[calc(100vw-2rem)] sm:w-120">
        <div class="flex flex-col gap-4 p-4">
          <h2 class="text-xl leading-tight font-bold capitalize-first">
            {{ $t('button.add') }}
          </h2>
          <div
            v-for="(items, idx) in solutions"
            :key="idx"
            class="grid flex-1 grid-cols-[repeat(auto-fill,minmax(12rem,1fr))] gap-2"
            :class="{ 'hidden md:grid': !mobileGroups[idx] }"
          >
            <button
              v-for="item in items.filter((x) => x.gate)"
              :key="item.name"
              class="flew-row flex flex-row items-center gap-1.5 rounded-md border bg-primary-100 p-1.5 text-left text-gray-700 hover:bg-primary-400 hover:text-contrast-primary focus:outline-none active:scale-95 active:bg-primary-400 dark:border-slate-600 dark:bg-primary-800 dark:text-white dark:hover:bg-primary-600 dark:active:bg-primary-600"
              :data-testid="`quick-add-btn-${item.id}`"
              @click="
                () => {
                  $router.push(item.to)
                  close()
                }
              "
            >
              <div
                class="flex h-5 w-5 shrink-0 items-center justify-center sm:h-5 sm:w-5"
              >
                <FontAwesomeIcon :icon="['fal', item.icon]" size="lg" />
              </div>
              <p class="w-full truncate text-sm font-medium capitalize">
                {{ item.name }}
              </p>
            </button>
          </div>
        </div>
      </PopoverPanel>
    </Float>
  </Popover>
</template>

<script>
import {
  Popover,
  PopoverButton,
  PopoverOverlay,
  PopoverPanel
} from '@headlessui/vue'
import { Float } from '@headlessui-float/vue'
import { mapGetters } from 'vuex'
import { Country } from '@/assets/enums'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'QuickAdd',
  components: {
    Float,
    FontAwesomeIcon,
    Popover,
    PopoverPanel,
    PopoverButton,
    PopoverOverlay
  },
  data() {
    return {
      Country: Country
    }
  },
  computed: {
    ...mapGetters({
      metadata: 'metadata/getInitialMetadata'
    }),
    // Groups shown on mobile: the ones holding an entry flagged `mobile`
    mobileGroups() {
      return this.solutions.map((items) => items.some((x) => x.mobile))
    },
    solutions() {
      return [
        [
          {
            name: this.$t('global.dossier'),
            to: { name: 'dossier_create_route' },
            icon: 'user',
            gate: this.$can('manage_dossier'),
            id: 'dossier',
            // On mobile the scope is the dossier creation only.
            mobile: true
          }
        ],
        [
          {
            name: this.$t('global.invoicing_type.INV'),
            to: { name: 'invoice_wizard_route' },
            icon: 'file-invoice',
            gate: this.$can('manage_invoicing'),
            id: 'invoice'
          },
          {
            name: this.$t('global.invoicing_type.INV_PRO'),
            to: { name: 'invoice_proforma_wizard_route' },
            icon: 'file-invoice',
            gate: this.$can('manage_invoicing'),
            id: 'invoice-proforma'
          },
          {
            name: this.$t('global.invoicing_type.SUPORD'),
            to: { name: 'purchase_order_wizard_route' },
            icon: 'file-invoice',
            gate: this.$can('manage_invoicing'),
            id: 'purchase-order'
          },
          {
            name: this.$t('global.invoicing_type.QUO'),
            to: { name: 'quote_wizard_route' },
            icon: 'file-invoice',
            gate: this.$can('manage_invoicing'),
            id: 'quote'
          },
          {
            name: this.$t('global.invoicing_type.CN'),
            to: { name: 'credit_note_wizard_route' },
            icon: 'file-invoice',
            gate: this.$can('manage_invoicing'),
            id: 'credit-note'
          }
        ],
        [
          {
            name: this.$t('global.email'),
            to: { name: 'mail_box_create_route' },
            icon: 'envelope',
            gate: this.$can('see_content'),
            id: 'email'
          }
        ]
      ]
    }
  }
}
</script>
